import { render, staticRenderFns } from "./Ctes.vue?vue&type=template&id=63c27fc4&scoped=true"
import script from "./Ctes.vue?vue&type=script&lang=js"
export * from "./Ctes.vue?vue&type=script&lang=js"
import style0 from "./Ctes.vue?vue&type=style&index=0&id=63c27fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c27fc4",
  null
  
)

export default component.exports